var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIcnList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1C1.44772 1 1 1.44771 1 2V2.8C1 3.35228 1.44771 3.8 2 3.8H2.8C3.35228 3.8 3.8 3.35229 3.8 2.8V2C3.8 1.44772 3.35229 1 2.8 1H2ZM5.20002 2.89999H15V1.89999H5.20002V2.89999ZM5.20002 8.5H15V7.5H5.20002V8.5ZM15 14.1H5.20002V13.1H15V14.1ZM1 7.60001C1 7.04773 1.44772 6.60001 2 6.60001H2.8C3.35229 6.60001 3.8 7.04773 3.8 7.60001V8.40001C3.8 8.9523 3.35228 9.40001 2.8 9.40001H2C1.44771 9.40001 1 8.9523 1 8.40001V7.60001ZM2 12.2C1.44772 12.2 1 12.6477 1 13.2V14C1 14.5523 1.44771 15 2 15H2.8C3.35228 15 3.8 14.5523 3.8 14V13.2C3.8 12.6477 3.35229 12.2 2.8 12.2H2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnList);
export default __webpack_public_path__ + "static/media/icn-list.910ea6802ad72d6db4b3d97fd855cf47.svg";
export { ForwardRef as ReactComponent };